import { Button, Col, Result, Row } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { NotAuthorizedLayout } from '../../components/layouts'
import Routes from '../../constants/routes'
import { useDocumentTitle } from '../../hooks/useDocumentTitle'

const NotFoundPage = () => {
    useDocumentTitle('Not found')

    return (
        <NotAuthorizedLayout>
            <Row justify='center' align='middle' className='flex-1'>
                <Col xs={24} className='text-center'>
                    <Result
                        status='404'
                        title='404'
                        subTitle='Sorry, the page you visited does not exist.'
                        extra={
                            <Link to={Routes.HOME}>
                                <Button type='primary'>Back Home</Button>
                            </Link>
                        }
                    />
                </Col>
            </Row>
        </NotAuthorizedLayout>
    )
}

export default NotFoundPage
